import React from 'react';
import { Spinner } from '@shared/components/ui/Spinner';

interface PendingOrdersStatesProps {
  isLoading: boolean;
  error: unknown;
}

export const PendingOrdersStates: React.FC<PendingOrdersStatesProps> = ({ isLoading, error }) => {
  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center w-full min-h-[calc(100vh-150px)] p-8">
        <Spinner size="md" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-center text-destructive">
          <p>Error al cargar los pedidos pendientes</p>
          <p className="text-sm text-muted-foreground mt-2">
            {error instanceof Error ? error.message : 'Error desconocido'}
          </p>
        </div>
      </div>
    );
  }

  return null;
};
